import React, { forwardRef } from "react";
import PhoneInput from "react-phone-number-input";
import { cn } from "@/lib/utils";
import 'react-phone-number-input/style.css';

export interface PhoneInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  value?: string;
  onChange?: (value: string | undefined) => void;
}

const PhoneInputComponent = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ className, value, onChange, ...props }, ref) => {
    return (
      <div className={cn("relative", className)}>
        <PhoneInput
          value={value}
          onChange={onChange}
          defaultCountry="LK"
          international
          countryCallingCodeEditable={false}
          className={cn(
            "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          )}
          style={{
            '--PhoneInputCountryFlag-height': '1em',
            '--PhoneInputCountryFlag-borderRadius': '0.25rem',
          } as React.CSSProperties}
          {...props}
        />
      </div>
    );
  }
);
PhoneInputComponent.displayName = "PhoneInput";

export { PhoneInputComponent as PhoneInput };